import type { RouteDefinition } from "../route-definition.ts";

export const productCreationRoutes = {
  coworlds: {
    path: "/coworlds",
    scope: "static",
    bucket: "app",
    entry: "nav",
    disposition: "page",
  },
  policies: {
    path: "/policies",
    scope: "static",
    bucket: "app",
    entry: "nav",
    disposition: "page",
  },
  leagueSettings: {
    path: "/leagues/:leagueId/settings",
    scope: "static",
    bucket: "app",
    entry: "parent",
    disposition: "page",
  },
  coworldShared: {
    path: "/coworlds/:coworldName",
    scope: "static",
    bucket: "app",
    entry: "parent",
    disposition: "page",
  },
  coworldManage: {
    path: "/coworlds/:coworldName/manage",
    scope: "static",
    bucket: "app",
    entry: "parent",
    disposition: "page",
  },
  coworldNewRun: {
    path: "/coworlds/:coworldName/runs/new",
    scope: "static",
    bucket: "app",
    entry: "parent",
    disposition: "page",
  },
  coworldRun: {
    path: "/coworlds/:coworldName/runs/:requestId",
    scope: "static",
    bucket: "app",
    entry: "parent",
    disposition: "page",
  },
  policyVersion: {
    path: "/policies/versions/:policyVersionId",
    scope: "static",
    bucket: "app",
    entry: "parent",
    disposition: "page",
  },
  policy: {
    path: "/policies/:policyName",
    scope: "static",
    bucket: "app",
    entry: "parent",
    disposition: "page",
  },
  player: {
    path: "/players/:playerId",
    scope: "static",
    bucket: "app",
    entry: "parent",
    disposition: "page",
  },
  tournament: {
    path: "/tournaments/:tournamentId",
    scope: "static",
    bucket: "app",
    entry: "parent",
    disposition: "page",
  },
  experienceRequest: {
    path: "/experience-requests/:requestId",
    scope: "static",
    bucket: "app",
    entry: "parent",
    disposition: "page",
  },
  coworldsText: {
    path: "/coworlds/llms.txt",
    scope: "static",
    bucket: "app",
    entry: "direct",
    disposition: "document",
  },
} as const satisfies Record<string, RouteDefinition>;
